export default "__VITE_ASSET__Yi45TW_R__"